module.exports = __webpack_public_path__ + "media/images/ipaf_3b-c0576c29eed7ea1325e0825bfcfe931c.png";